const teaserTextBlock = () => {
  const createHover = function (blocks, teaserSelector) {
    blocks.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        item.classList.add('block--active');
      });

      item.addEventListener('mouseleave', () => {
        item.classList.remove('block--active');
      });
    });

    blocks.forEach((item) => {
      let teaser = item.querySelector(teaserSelector);

      window.addEventListener('mousemove', (e) => {
        const coords = item.getBoundingClientRect();
        const x = e.clientX - coords.left - (teaser.offsetWidth / 2);
        const y = e.clientY - coords.top - (teaser.offsetHeight / 2);
        teaser.style.transform = `translate(${x}px, ${y}px)`;
      });
    });

  };

  // ховер на изображениях-ссылках
  const imageBlocks = document.querySelectorAll('.special__image');

  if (imageBlocks.length !== 0) {
    createHover(imageBlocks, '.teaser__image');
  }

  // ховер на событиях
  const newsBlocks = document.querySelectorAll('.events__item');

  if (newsBlocks.length !== 0) {
    createHover(newsBlocks, '.teaser__event');
  }

  // ховер на проектах
  const projectsBlocks = document.querySelectorAll('.projects__item');

  if (projectsBlocks.length !== 0) {
    createHover(projectsBlocks, '.teaser__image');
  }

  // ховер-выделение текста
  const textBlocks = document.querySelectorAll('.text-block');

  if (textBlocks.length !== 0) {
    textBlocks.forEach((item) => {
      item.addEventListener('mouseenter', (e) => {
        item.classList.add('text-block--active');
      });

      item.addEventListener('mouseleave', (e) => {
        item.classList.remove('text-block--active');
      });

      const textMask = item.querySelector('.text-block__mask');
      const textMaskSpan = item.querySelector('.text-block__mask span');

      textMaskSpan.style.width = `${item.offsetWidth}px`;
      window.addEventListener('mousemove', (e) => {
        const coords = item.getBoundingClientRect();
        const x = e.clientX - coords.left - (textMask.offsetWidth / 2);
        const y = e.clientY - coords.top - (textMask.offsetHeight / 2);

        textMask.style.transform = `translate(${x}px, ${y}px)`;
        textMaskSpan.style.transformOrigin = `${x}px ${y}px`;
        textMaskSpan.style.transform = `translate(${(x) * -1}px, ${(y) * -1}px)`;
      });
    });
  }
};

export {teaserTextBlock};
